import PropTypes from 'prop-types';
import { useState } from 'react';

/** Components */
import Link from 'components/Link';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import useResponsive from 'hooks/useResponsive';
import Typography from '@mui/material/Typography';

const categoryChildrenListDefaultPropSx = {};

const categoryChildrenListDefaultPropCategory = {
  name: '',
  slug: '',
  description: '',
  shortDescription: '',
  seoTitle: '',
  seoDescription: '',
  parent: {},
  children: [],
};

const CategoryChildrenList = ({
  category = categoryChildrenListDefaultPropCategory,
  sx = categoryChildrenListDefaultPropSx,
}) => {
  const isTablet = useResponsive('down', 'md');
  const [selectedCategory, setSelectedCategory] = useState(-1);

  const handleCategoriesButtonHover = (index) => {
    setSelectedCategory(index);
  };

  const componentStyles = isTablet
    ? {
        grid: {},
        loadingNameWidth: 200,
        textAlign: 'center',
        loadingChipArraySize: 3,
      }
    : {
        grid: { mb: 1 },
        loadingNameWidth: 300,
        textAlign: 'initial',
        loadingChipArraySize: 10,
      };

  const chipContainerStyle = !isTablet
    ? {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 1,
      }
    : {
        display: 'flex',
        overflow: 'auto',
        pb: 0.25,
        mt: 1,
      };

  return (
    <Grid container sx={{ ...sx }}>
      <Grid
        xs={12}
        item
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        {...componentStyles.grid}
      >
        <Typography component="h1" variant="h4" textAlign={componentStyles.textAlign} marginTop={1}>
          {`Wholesale ${category?.name}`}
        </Typography>
      </Grid>
      {category?.shortDescription && (
        <Grid
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', maxWidth: 1100, margin: '0 auto' }}
          {...componentStyles.grid}
        >
          <Typography
            textAlign="center"
            marginTop={1}
            marginBottom={1}
            variant="body2"
            component="div"
            dangerouslySetInnerHTML={{ __html: category?.shortDescription }}
          />
        </Grid>
      )}
      <Grid item xs={12} sx={chipContainerStyle}>
        {category?.children?.map((child, index) => (
          <Chip
            component={Link}
            href={`/product-category/${child.slug}`}
            variant="outlined"
            label={child.name}
            title={child.name}
            sx={[
              {
                mx: 0.5,
                my: 0.25,
                '@media(max-width: 600px)': {
                  ml: 0,
                  mr: 0.5,
                },
              },
              selectedCategory === index
                ? {
                    backgroundColor: 'grey.100',
                    cursor: 'pointer',
                  }
                : '',
            ]}
            key={`chip-subcategory-${child.slug}`}
            onMouseEnter={() => handleCategoriesButtonHover(index)}
            onMouseLeave={() => setSelectedCategory(-1)}
          />
        ))}
      </Grid>
    </Grid>
  );
};

CategoryChildrenList.propTypes = {
  sx: PropTypes.shape({}),
  category: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    description: PropTypes.string,
    shortDescription: PropTypes.string,
    seoTitle: PropTypes.string,
    seoDescription: PropTypes.string,
    parent: PropTypes.shape({}),
    children: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

export default CategoryChildrenList;
